module.exports = __webpack_public_path__ + "static/img/ndvi_7.30bb1d57.jpg";